var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.historyReadOnly
    ? _c(
        "div",
        {
          class: {
            "mt-5": _vm.$uiHelpers.isMobileOrTablet,
            "mt-4": !_vm.$uiHelpers.isMobileOrTablet
          }
        },
        [
          _c(
            "history-wrapper",
            { attrs: { title: _vm.$t("feeding") } },
            _vm._l(_vm.feedingData, function(item) {
              return _c("history-healthy-habits-item", {
                key: item.id,
                attrs: {
                  id: item.id,
                  name: _vm.$i18nHelpers.normalize(item.name),
                  frequencyId: item.frequencyId,
                  unit: item.unit,
                  createdHabitId: item.createdHabitId
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "history-wrapper",
            { attrs: { title: _vm.$t("exercise") } },
            _vm._l(_vm.exerciseData, function(item) {
              return _c("history-healthy-habits-item", {
                key: item.id,
                attrs: {
                  id: item.id,
                  name: _vm.$i18nHelpers.normalize(item.name),
                  frequencyId: item.frequencyId,
                  unit: item.unit,
                  createdHabitId: item.createdHabitId
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "history-wrapper",
            { attrs: { title: _vm.$t("habits") } },
            _vm._l(_vm.habitsData, function(item) {
              return _c("history-healthy-habits-item", {
                key: item.id,
                attrs: {
                  id: item.id,
                  name: _vm.$i18nHelpers.normalize(item.name),
                  frequencyId: item.frequencyId,
                  unit: item.unit,
                  createdHabitId: item.createdHabitId
                }
              })
            }),
            1
          )
        ],
        1
      )
    : _c("div", {
        domProps: { innerHTML: _vm._s(_vm.$t("canNotAccessReadOnly")) }
      })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a656b7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a656b7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HistoryHealthyHabitsSection.vue
// module id = 3829
// module chunks = 37